import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export const UserSubpageWrapper = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx("section", {
        className: "relative w-full md:max-w-[1126px] mx-auto",
        children: children
    });
};
